export { default } from './OffersBlock';
